import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

import Icon, { IconName } from '@/components/Icon/Icon';
import Link from '@/components/Link/Link';
import type { FooterMenuContent } from '@/contentful/contentful-exports';
import useViewPortSize from '@/hooks/useViewportSize';
import { chunkIntoN } from '@/utils/array';

import useStyles from './SolarByState.styles';
export interface SolarByStateProps {
  solarByStateOpen: boolean;
  setSolarByStateOpen: (value: boolean) => void;
  solarByStateMenu: FooterMenuContent;
  isOnDark: boolean;
}

export default function SolarByState({
  solarByStateOpen,
  setSolarByStateOpen,
  solarByStateMenu,
  isOnDark,
}: SolarByStateProps) {
  const { isExtraSmall } = useViewPortSize();
  const { classes, cx } = useStyles({ isOnDark });

  const handleChange = (
    // biome-ignore lint/correctness/noUnusedFunctionParameters: Automated migration to Biome
    event: React.ChangeEvent<object>,
    isExpanded: boolean
  ) => {
    setSolarByStateOpen(isExpanded);
  };

  const solarByStateLinkColumns = chunkIntoN(
    solarByStateMenu.fields.links || [],
    isExtraSmall ? 2 : 3
  );

  return (
    <Accordion
      classes={{ root: classes.accordionRoot }}
      expanded={solarByStateOpen}
      square
      onChange={handleChange}
    >
      {/** biome-ignore lint/correctness/useUniqueElementIds: Automated migration to Biome */}
      <AccordionSummary
        aria-controls='solar-by-state'
        id='solar-by-state-header'
        classes={{
          root: cx(
            classes.accordionSummaryRoot,
            solarByStateOpen && classes.accordionSummaryRootExpanded
          ),
          content: classes.accordionSummaryContent,
        }}
      >
        <div className={classes.expandIcon}>
          <Icon
            name={
              solarByStateOpen ? IconName.CHEVRON_DOWN : IconName.CHEVRON_RIGHT
            }
            width={12}
          />
        </div>
        <span>Solar by State</span>
      </AccordionSummary>
      <AccordionDetails classes={{ root: classes.accordionDetailsRoot }}>
        {solarByStateLinkColumns.map((linkColumn, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: Automated migration to Biome
          <div className={classes.solarByStateColumn} key={index}>
            {linkColumn.map(({ fields: { text, url } }) => (
              <div className={classes.solarByStateColumnItem} key={text}>
                <Link href={url} className={classes.linkColor}>
                  {text}
                </Link>
              </div>
            ))}
          </div>
        ))}
      </AccordionDetails>
    </Accordion>
  );
}
